import React from 'react';
import './loading.css';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Loading = () => {


  return (
    // <div  className="loding-body" > 
    // </div>
    <div >
      <div >
        <table>
          <tr>
            <td width={30} >
              <div className="loading-shimmer" style={{ width: '30px', height: '30px' }}></div>
            </td>

            <td>
              <table>
                <tr>
                  <div className="loading-shimmer" style={{ height: '12px' }}></div>
                </tr>
                <tr>
                  <div className="loading-shimmer" style={{ height: '8px' }}></div>
                </tr>
               
              </table>

            </td>
          </tr>
        </table>
      </div>
    </div>

  );
};

export default Loading;
